var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.hero},[_c('div',{class:_vm.$style.container},[_c('app-image',{class:_vm.$style.image,attrs:{"x1":"/images/photos/camp/summer-camp-2024-open@1x.png","x2":"/images/photos/camp/summer-camp-2024-open@2x.png","alt":"Summer Camp","webp":"/images/photos/camp/summer-camp-2024-open.webp"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e17e60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CampHero.vue
// module id = null
// module chunks = 